import React from 'react';
import PropTypes from "prop-types";
import PreferencesSection from "../PreferencesSection";
import css from "./OfficeHours.scss";
import MinimumAppointmentDuration from 'common/MinimumAppointmentDuration';
import { getWord } from 'utils/tenant';
import { ifFieldEmptyReturnDefault } from 'utils/text';
import { StaffAppointmentPreferences } from 'utils/types';
import OfficeHourSchedulingOptions from "./OfficeHourSchedulingOptions";

// Appointment scheduling settings for staff users' office hour.
const OfficeHours = ({ appointmentPreferences, setValue }) => {
    return (
        <PreferencesSection isStaff
                            className={css['text-options']} 
                            headerText={"Office Hour Defaults"}
                            descriptionText={'Customize appointment scheduling settings.'}>
            <div className={css['office-hour']}>
                <label htmlFor="minApptLength">Minimum Appointment Length</label>
                <MinimumAppointmentDuration id="minApptLength"
                                            ariaLabel="Minimum Appointment Length"
                                            onChange={(minutes) => {setValue({ minAppTime: minutes })}}
                                            value={ifFieldEmptyReturnDefault(appointmentPreferences.minAppTime, 15)} />
            </div>
            <div className={css['scheduling-deadline']}>
                <span className={css['scheduling-heading']} id="schedulingDeadline">Scheduling Deadline</span>
                <p>Set a deadline for students to schedule appointments prior to
                    the start of your {getWord('officeHours', true)}.</p>
                <OfficeHourSchedulingOptions appointmentPreferences={appointmentPreferences}
                                             setValue={setValue}/>
            </div>
        </PreferencesSection>
    );
};

OfficeHours.propTypes = {
    appointmentPreferences: StaffAppointmentPreferences,
    setValue: PropTypes.func
};

export default OfficeHours;
